import React from 'react'
import Banner from '../LandingPage/Banner/Banner'
import Team from '../LandingPage/Team/Team'
import Services from './Services/Services'
import Contact from './Contact/Contact'
import CallToAction from './CallToAction/CallToAction'
const LandingPage = () => {
    return (
        <div>
            <Banner />
            <Services />
            <Team />
            <CallToAction />
            <Contact />
        </div>
    )
}

export default LandingPage
